import { Button, CircularProgress, Stack } from "@mui/material";
import React from "react";

export default function CustomDialogFooter({
  handleClose,
  onSubmit,
  state,
  disabled,
  divider = false,
  submitButton = "Save",
  cancelButton = "Cancel",
  hasCancelButton = true,
  loading = false,
  submitButtonColor = "primary",
  sx = {},
}) {
  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      // style={{
      //   position: "absolute",
      //   left: 0,
      //   right: 0,
      //   bottom: 0,
      //   padding: "8px 20px 20px 20px",
      //   background: "#fff",
      // }}
      gap="8px"
      px="16px"
      py="16px"
      borderTop={divider ? 1 : 0}
      borderColor="divider"
      sx={sx}
    >
      {hasCancelButton && (
        <Button
          variant="outlined"
          color="gray2"
          onClick={() => {
            handleClose(false);
          }}
        >
          {cancelButton}
        </Button>
      )}
      <Button
        variant="contained"
        color={submitButtonColor}
        onClick={() => {
          onSubmit(state);
        }}
        disabled={disabled}
        startIcon={
          loading ? <CircularProgress size={20} color="inherit" /> : null
        }
      >
        {submitButton}
      </Button>
    </Stack>
  );
}
